/**
 * Ultima plasa: o eroare de randare nu are voie sa lase ecranul alb.
 *
 * Nu inghite nimic — eroarea ajunge in consola exact cum a fost aruncata. Ce
 * face in plus e sa ii spuna clientului ca aplicatia s-a oprit, in loc sa il
 * lase sa astepte in fata unei pagini goale.
 */

import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[web] randarea s-a oprit:", error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (error === null) return this.props.children;
    return (
      <div className="mx-auto max-w-readable p-6">
        <div className="rounded-card border border-danger bg-surface p-4">
          <h1 className="text-lg font-bold text-danger">Aplicația s-a oprit</h1>
          <p className="mt-2 text-sm text-ink">
            Pagina nu a putut fi afișată. Reîncarcă aplicația; dacă se repetă, comanda se poate plasa
            telefonic.
          </p>
          <p className="mt-2 text-xs text-ink-muted">{error.message}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded-control bg-brand px-4 py-2.5 font-semibold text-brand-contrast"
          >
            Reîncarcă
          </button>
        </div>
      </div>
    );
  }
}
